export class Subscriber {
    lststrip: Strip[] = [];
}

export class Strip {
    avodaId: number;
    isShrOn: boolean;
    saparIdPurchase?: number;
    saparNamePurchase: string;
    openDateStr: string;
    status?: number;
    avodaInd?: number;
    cardId: string;
    closeDateStr: string;
    subscriberTypeCalc: string;
    sum: string;
   // subStr: string;
    lststripdetails: StripDetails[];
    isVisibleUseSubsBtn: boolean;
    avodaIndHelp?: number;
    customerId: number;
    typeSubs?: number;
    openDate?: string;
    closeDate?: string;
    saparId?: number;
    amount?: number;
    subscriberLabel: string;
    lastDeleted?: boolean = false;
}

export class StripDetails {
    ind: number;
    avodaInd: number;
    customerId: number;
    dateVisitStr: string;
    status: number;
    joul: string;
    ms: string;
    hairType: string;
    skinType: string;
    typeHandle: string;
    saparid: number;
    saparName: string;
    comments: string;
    avodaIndHelp?: number;
    avodaId: number;
}

export class TmpValues {
    sumtmp: string;
    saparNamePurchasetmp: string;
    cardIdtmp: string;
}
